import { DISHES } from "../data/site";
import { useContent } from "@/context/ContentContext";
import { resolveImg } from "@/lib/api";
import { Reveal } from "./Reveal";

export const FeaturedDishes = () => {
  const { content } = useContent();
  const dishes = content?.dishes?.length ? content.dishes : DISHES;
  return (
    <section id="dishes" data-testid="featured-dishes" className="bg-beige py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-14 md:mb-20">
          <Reveal>
            <span className="font-heading text-gold-dark uppercase tracking-[0.3em] text-sm">
              — Straight From The Kitchen
            </span>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 font-heading text-4xl md:text-5xl font-semibold text-charcoal">
              Featured <span className="font-script text-burgundy text-5xl md:text-6xl">Dishes</span>
            </h2>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {dishes.map((dish, i) => (
            <Reveal
              key={`${dish.name}-${i}`}
              delay={i * 0.06}
              className="group relative overflow-hidden rounded-3xl shadow-[0_4px_20px_rgba(122,28,34,0.06)] hover:shadow-[0_18px_40px_rgba(122,28,34,0.18)] transition-all duration-500 h-[380px]"
            >
              <div
                data-testid={`dish-card-${i}`}
                className="relative w-full h-full"
              >
                <img
                  src={resolveImg(dish.img)}
                  alt={dish.name}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-charcoal/90 via-charcoal/20 to-transparent" />
                <div className="absolute bottom-0 left-0 p-6">
                  <h3 className="font-heading text-2xl md:text-3xl text-cream font-semibold">
                    {dish.name}
                  </h3>
                  <p className="mt-1.5 font-body text-cream/80 text-sm max-w-xs opacity-0 translate-y-3 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500">
                    {dish.desc}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
